<template>
    <form
        @submit.prevent="editUser"
        :action="url"
        method="post"
        class="p-4 bg-white rounded shadow-lg space-y-4 border-2 border-green-500"
    >
        <heading-2>Update User Info</heading-2>

        <div
            v-if="showNotification"
            class="notification success"
        >
            A new verification link has been sent to the email address you provided during registration.
        </div>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <text-input
                label="First Name"
                name="first_name"
                type="text"
                v-model="form.first_name"
                :error="form.errors.first_name"
            />
            <text-input
                label="Last Name"
                name="last_name"
                type="text"
                v-model="form.last_name"
                :error="form.errors.last_name"
            />
        </div>

        <text-input
            label="Email"
            name="email"
            type="email"
            v-model="form.email"
            :error="form.errors.email"
        />

        <div class="flex justify-end items-center space-x-4">
            <transition
                enter-from-class="opacity-0"
                enter-active-class="transition-opacity ease-in duration-200"
                enter-to-class="opacity-100"
                leave-from-class="opacity-100"
                leave-active-class="transition-opacity ease-out duration-200"
                leave-to-class="opacity-0"
            >
                <div
                    v-if="form.recentlySuccessful"
                    class="text-gray-500"
                >
                    Saved.
                </div>
            </transition>

            <loading-button
                :loading="form.processing"
                type="submit"
                class="btn btn-green"
            >
                Update
            </loading-button>
        </div>

    </form>
</template>

<script>
import TextInput from './shared/TextInput.vue'
import LoadingButton from './shared/LoadingButton.vue'
import Heading2 from './shared/Heading2.vue'
import Form from '@/functions/Form'
import emitter from 'tiny-emitter/instance'

export default {
    props: {
        url: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            form: Form({
                first_name: this.$store.state.user.first_name,
                last_name: this.$store.state.user.last_name,
                email: this.$store.state.user.email,
            }),
            showNotification: false,
        }
    },
    methods: {
        editUser() {
            this.showNotification = false

            this.form.patch(this.url, {
                onSuccess: (user) => {
                    this.showNotification = this.form.dirty('email')
                    this.$store.commit('updateUser', user)
                }
            })
        }
    },
    components: {
        TextInput,
        LoadingButton,
        Heading2,
    }
}
</script>
